import Phaser from 'phaser';

export type ControlState = {
  left: boolean;
  right: boolean;
  up: boolean;
  jump: boolean;
  jumpHeld: boolean;
  action: boolean;
};

export function createEmptyControls(): ControlState {
  return { left: false, right: false, up: false, jump: false, jumpHeld: false, action: false };
}

export function attachKeyboard(scene: Phaser.Scene, target: ControlState) {
  const keyLeft = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT);
  const keyRight = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT);
  const keyA = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.A);
  const keyD = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.D);
  const keyUp = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
  const keyW = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.W);
  const keySpace = scene.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);

  scene.events.on('update', () => {
    // Assign keyboard state directly each frame to avoid stale values.
    // Virtual controls merge on top via their own update handler.
    target.left = keyLeft.isDown || keyA.isDown;
    target.right = keyRight.isDown || keyD.isDown;
    target.up = keyUp.isDown || keyW.isDown;
    target.jumpHeld = keySpace.isDown;
    const justSpace = Phaser.Input.Keyboard.JustDown(keySpace);
    target.jump = justSpace;
    target.action = justSpace;
  });
}
